import React from "react";
import { useAuth } from "../Contexts/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { FaDesktop, FaFileAlt, FaUsersCog, FaSignOutAlt, FaShieldAlt } from "react-icons/fa";
import { isAdminLike } from "../../services/utils/utiltyFunctions";
import "./BottomNavbar.css";

const BottomNavBar = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const items = [
    { path: "/dashboard",  icon: <FaDesktop size={16} />,  label: "Dashboard", danger: false },
    { path: "/checklogs",  icon: <FaFileAlt size={16} />,  label: "Logs",      danger: false },
    ...(isAdminLike(user?.role) ? [
      { path: "/auditlogs", icon: <FaShieldAlt size={16} />, label: "Audit", danger: false },
      { path: "/admin",     icon: <FaUsersCog size={16} />,  label: "Admin", danger: false },
    ] : []),
    { path: null, icon: <FaSignOutAlt size={16} />, label: "Logout", danger: true },
  ];

  return (
    <nav className="bottom-nav">
      {items.map((item) => (
        <button
          key={item.label}
          className={`bn-btn${item.danger ? " bn-danger" : ""}${item.path && isActive(item.path) ? " bn-active" : ""}`}
          onClick={() => item.path ? navigate(item.path) : handleLogout()}
        >
          <span className="bn-icon">{item.icon}</span>
          <span className="bn-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNavBar;
